/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Wrapped_TitleInputs */

const en_us2_progress_wrapped_title = /** @type {(inputs: Progress_Wrapped_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your week in review`)
};

const pt_br2_progress_wrapped_title = /** @type {(inputs: Progress_Wrapped_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua retrospectiva`)
};

const es_419_progress_wrapped_title = /** @type {(inputs: Progress_Wrapped_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu resumen de la semana`)
};

const pt_pt2_progress_wrapped_title = /** @type {(inputs: Progress_Wrapped_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua retrospetiva`)
};

const fr_fr2_progress_wrapped_title = /** @type {(inputs: Progress_Wrapped_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta semaine en bref`)
};

const de_de2_progress_wrapped_title = /** @type {(inputs: Progress_Wrapped_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Wochenrückblick`)
};

const it_it2_progress_wrapped_title = /** @type {(inputs: Progress_Wrapped_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo riepilogo`)
};

/**
* | output |
* | --- |
* | "Your week in review" |
*
* @param {Progress_Wrapped_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_wrapped_title = /** @type {((inputs?: Progress_Wrapped_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Wrapped_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_wrapped_title(inputs)
	if (locale === "es-419") return es_419_progress_wrapped_title(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_wrapped_title(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_wrapped_title(inputs)
	if (locale === "de-DE") return de_de2_progress_wrapped_title(inputs)
	if (locale === "it-IT") return it_it2_progress_wrapped_title(inputs)
	return en_us2_progress_wrapped_title(inputs)
});
export { progress_wrapped_title as "progress.wrapped_title" }